import request from '@/utils/request'

const PREFIX = '/signstore/photolive'

/** 解包 crm-app ApiResult：{ status/code, msg, data } */
function unwrap(res) {
  if (res == null) return res
  if (typeof res !== 'object') return res
  const ok = res.success === true || res.status === 200 || res.code === 200 || res.ok === true
  if (Object.prototype.hasOwnProperty.call(res, 'data')) {
    if (ok || res.data != null) return res.data
    const err = new Error(res.msg || res.message || '请求失败')
    err.msg = res.msg || res.message
    throw err
  }
  return res
}

export function getPhotoLiveAlbum(albumCode) {
  return request.get(PREFIX + '/album/' + encodeURIComponent(albumCode)).then(unwrap)
}

export function getPhotoLivePhotos(albumCode, params) {
  return request.get(PREFIX + '/album/' + encodeURIComponent(albumCode) + '/photos', { params }).then(unwrap)
}

export function postPhotoLiveView(albumCode, uid) {
  return request.post(PREFIX + '/album/' + encodeURIComponent(albumCode) + '/view', null, {
    params: { uid }
  }).then(unwrap)
}

export function photoLiveUploadAuth(data) {
  return request.post(PREFIX + '/upload/auth', data).then(unwrap)
}

export function photoLiveStaffUpload(data) {
  return request.post(PREFIX + '/upload', data).then(unwrap)
}

/** 本相册工作人员已上传的照片，含审核状态 */
export function photoLiveStaffMine(uploadToken, page, size) {
  return request.get(PREFIX + '/upload/mine', {
    params: { uploadToken, page: page || 0, size: size || 60 }
  }).then(unwrap)
}

export function photoLiveUserUpload(data) {
  return request.post(PREFIX + '/user-upload', data).then(unwrap)
}

export function photoLiveDownload(data) {
  return request.post(PREFIX + '/photos/download', data).then(unwrap)
}

export function photoLiveUploadFile(formData) {
  return request.post(PREFIX + '/upload/file', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(unwrap)
}

/** 观众上传选图（需相册开启 allowUserUpload） */
export function photoLiveUserUploadFile(formData) {
  return request.post(PREFIX + '/user-upload/file', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(unwrap)
}

/** 本相册我下载过的照片 */
export function getPhotoLiveMine(albumCode, uid, page, size) {
  return request.get(PREFIX + '/album/' + encodeURIComponent(albumCode) + '/mine', {
    params: { uid, page: page || 0, size: size || 40 }
  }).then(unwrap)
}

/** 稳定观众标识，用于「我的下载」 */
export function getPhotoLiveUid() {
  const key = 'photoLiveUid'
  try {
    let uid = localStorage.getItem(key)
    if (!uid) {
      uid = 'h5_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10)
      localStorage.setItem(key, uid)
    }
    return uid
  } catch (e) {
    return 'h5_anon'
  }
}
